import React, { useState } from 'react';
import { ArrowLeft, Loader2, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function BookingPageIN() {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  return <main className="min-h-screen w-full bg-background text-foreground bg-noise selection:bg-blue-500/30 overflow-x-hidden" data-id="element-161">
      {/* Header */}
      <div className="w-full border-b border-white/5 bg-[#0a0a0f]/80 backdrop-blur-md sticky top-0 z-50" data-id="element-162">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between" data-id="element-163">
          <button onClick={() => navigate('/in')} className="flex items-center gap-2 text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-164">
            <ArrowLeft className="w-4 h-4" data-id="element-165" />
            <span data-id="element-166">Back</span>
          </button>
          <span className="label-caps text-[10px] sm:text-[11px] text-gray-500 tracking-[0.1em]" data-id="element-167">
            Faceless YouTube System
          </span>
        </div>
      </div>

      {/* Booking Content */}
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-10 md:py-16 relative z-10" data-id="element-168">
        <div className="text-center mb-8 md:mb-10" data-id="element-169">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white tracking-[-0.03em] mb-3" data-id="element-170">
            Book Your <span className="text-gradient" data-id="element-171">Strategy Call</span>
          </h1>
          <p className="text-xs sm:text-sm text-gray-400 max-w-md mx-auto leading-relaxed tracking-[0.01em]" data-id="element-172">
            Pick a time that works for you. After payment, we'll map out your
            faceless channel strategy.
          </p>
        </div>

        {/* Price Badge */}
        <div className="glass-panel rounded-2xl p-5 sm:p-6 border border-white/10 mb-8 max-w-2xl mx-auto" data-id="element-173">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6" data-id="element-174">
            <div data-id="element-175">
              <p className="text-lg font-bold text-white mb-1 flex items-center gap-2" data-id="element-176">
                <span data-id="element-177">💰</span> One-time fee: ₹500
              </p>
              <p className="text-xs text-gray-400" data-id="element-178">What you get:</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2" data-id="element-179">
              {['Personalized niche analysis', 'Custom monetization roadmap', 'Channel setup blueprint', '30-min 1-on-1 with an expert'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-180">
                  <Check className="w-3.5 h-3.5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-181" />
                  <span className="text-xs text-gray-300" data-id="element-182">{item}</span>
                </div>)}
            </div>
          </div>
        </div>

        {/* Booking Widget */}
        <div className="glass-panel rounded-2xl md:rounded-3xl p-2 sm:p-4 md:p-6 border border-white/10 relative" data-id="element-183">
          {isLoading && <div className="absolute inset-0 flex items-center justify-center z-10 rounded-2xl md:rounded-3xl bg-[#0a0a0f]/80" data-id="element-184">
              <div className="flex flex-col items-center gap-3" data-id="element-185">
                <Loader2 className="w-8 h-8 text-blue-500 animate-spin" data-id="element-186" />
                <p className="text-sm text-gray-400" data-id="element-187">Loading booking form...</p>
              </div>
            </div>}
          <iframe src="https://link.yourmarketingai.com/widget/booking/n5Pf2NuhKrY6E1mJXvzO" style={{
          width: '100%',
          minHeight: '900px',
          border: 'none',
          borderRadius: '1rem'
        }} scrolling="yes" id="n5Pf2NuhKrY6E1mJXvzO_1773300332046" onLoad={() => setIsLoading(false)} data-id="element-188" />
        </div>

        {/* Trust text */}
        <p className="label-caps text-[9px] md:text-[10px] text-gray-500 text-center mt-6 tracking-[0.12em]" data-id="element-189">
          Secure payment. Your spot is confirmed instantly.
        </p>
      </div>

      {/* Background orbs */}
      <div className="fixed top-0 right-0 w-[400px] h-[400px] bg-blue-600/5 rounded-full blur-[120px] translate-x-1/3 -translate-y-1/4 pointer-events-none" data-id="element-190" />
      <div className="fixed bottom-0 left-0 w-[400px] h-[400px] bg-purple-600/5 rounded-full blur-[120px] -translate-x-1/3 translate-y-1/4 pointer-events-none" data-id="element-191" />
    </main>;
}